import { Grid } from 'semantic-ui-react';
import cx from 'classnames';
import omit from 'lodash/omit';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import config from '@plone/volto/registry';
import type { BlockViewProps } from '@plone/types';
import type { ExpandableGridData } from './schema';
import styles from './styles.module.css';

type Props = BlockViewProps & {
  data: ExpandableGridData;
};

const ExpandableGridBlockView = (props: Props) => {
  const { data, path, className, style } = props;
  const metadata = props.metadata || props.properties;
  if (data.columns === undefined) {
    return null;
  }
  const blocksConfig =
    config.blocks.blocksConfig[data['@type']].blocksConfig ||
    props.blocksConfig;
  const location = {
    pathname: path,
  };

  const Container = config.getComponent('Container').component || 'div';
  return (
    <div
      className={cx('block three', data['@type'], className, styles.block)}
      style={style}
    >
      <Container>
        {data.headline && (
          <h2 className={cx('headline', styles.headline)}>{data.headline}</h2>
        )}

        <Grid stackable stretched columns={3} className={styles.grid}>
          {data.columns.map((column, index) => (
            <Grid.Column key={index} className={styles.column}>
              <RenderBlocks
                {...props}
                metadata={metadata}
                content={{
                  ...omit(data, 'columns'),
                  ...column,
                }}
                location={location}
                blocksConfig={blocksConfig}
                // isContainer
              />
            </Grid.Column>
          ))}
        </Grid>
      </Container>
    </div>
  );
};

export default withBlockExtensions(ExpandableGridBlockView);
